<template>
  <v-app
    style="min-width: 320px;"
  >
    <slot />
    <ChatBot />
  </v-app>
</template>

<script>
import ChatBot from '@/components/ChatBot.vue';

export default {
  name: 'Wrapper',

  components: {
    ChatBot,
  },
};
</script>
